import { render } from "./AnnouncementsCreate.vue?vue&type=template&id=0fb164bf"
import script from "./AnnouncementsCreate.vue?vue&type=script&lang=js"
export * from "./AnnouncementsCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__